<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <v-btn icon="mdi-chevron-left" @click="$router.replace(`/sells`)" variant="elevated" :density="$vuetify.display.mdAndUp ? 'compact' : 'comfortable' " color="primary" ></v-btn>
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">Informazioni sulla vendita</h2>
          <h3 class="mx-3" v-else>Informazioni sulla vendita</h3>
        </div>
        <div class="d-flex align-center justify-end" >
          <v-btn append-icon="mdi-pencil" @click="$router.push(`/sells/${$route.params.id}`)" size="small" color="primary" :disabled="loading || item?.block_edit" :loading="loading" >Modifica</v-btn>
        </div>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider class="mb-3" v-else></v-divider>
      </v-col>

      <v-col cols="12" class="d-flex align-center title fw-3">
        <span class="fw-6 mr-3">Utente</span> <a :href="'/#/users/' + item?.user._id" >{{item?.user.surname}} {{item?.user.name}}</a>
      </v-col>
      <v-col cols="12" class="title fw-3">
        <span class="fw-6">Prodotti nell'ordine:</span>
        <ul>
          <li v-for="item in item?.items"><a :href="'/#/kits/' + item.kit?._id" >{{item.kit?.title.it}}</a> - <a :href="'/#/products/' + item._id" >{{item.title.it}}</a></li>
        </ul>
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3">
        <span class="fw-6 mr-3">Prezzo totale</span> € {{total}}
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3">
        <span class="fw-6 mr-3">Data creazione ordine</span> {{formatDateTime(item?.creation_date)}}
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3">
        <span class="fw-6 mr-3">Data ultima modifica ordine</span> {{formatDateTime(item?.last_update)}}
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3" v-if="item">
        <span class="fw-6 mr-3" >Tipo di pagamento</span> {{formatPaymentMethod(item.payment_method)}}
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3">
        <span class="fw-6 mr-3">N° ricevuta / N° fattura / ID di pagamento</span> {{item?.payment_uid}}
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3">
        <span class="fw-6 mr-3">Con spedizione</span> <span v-if="item?.expedition">Sì</span><span v-else>No</span>
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3">
        <span class="fw-6 mr-3">Con Home Kit</span> <span v-if="item?.home_kit">Sì</span><span v-else>No</span>
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3">
        <span class="fw-6 mr-3">Con tessera (nuova o rinnovo)</span> <span v-if="item?.card">Sì</span><span v-else>No</span>
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3" v-if="item?.expedition">
        <span class="fw-6 mr-3">Indirizzo di spedizione</span> {{item.address?.name}}, {{item.address?.city}} ({{item.address?.province}}), {{item.address?.zip_code}}
      </v-col>
      <v-col cols="12" class="d-flex align-center title fw-3">
        <span v-if="item?.evaded" class="fw-6 mr-3 text-success font-weight-bold">ORDINE EVASO</span>
        <v-btn color="error" v-else rounded @click="evadiOrdine()">EVADI ORDINE</v-btn>
      </v-col>

      <v-col cols="12">
        <v-divider v-if="!loading"></v-divider>
        <v-progress-linear color="primary" class="w-100" indeterminate v-else height="2"></v-progress-linear>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <v-btn prepend-icon="mdi-chevron-left" @click="$router.replace(`/sells`)" variant="elevated" color="primary" density="compact">Indietro</v-btn>
        </div>
        <div class="d-flex align-center">
          <v-btn append-icon="mdi-pencil" size="small" color="primary" :disabled="loading || item?.block_edit" :loading="loading" @click="$router.push(`/sells/${$route.params.id}`)">Modifica</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">

  import {computed, inject, onMounted, ref} from "vue";
  import {type CartDisplay} from "@/models.ts"
  import utils from "@/utils";
  import {type Messages, Msg} from "@/plugins/messages.ts";
  import {useRoute, useRouter} from "vue-router";
  import api from "@/api";
  export default {
    setup (props, ctx) {
      const messages = inject('messages') as Messages
      const route  = useRoute()
      const router  = useRouter()

      const loading = ref<boolean>(false)
      const item = ref<CartDisplay|undefined>()

      const loadData = async () => {
        loading.value = true;
        const res = await api.get<CartDisplay>('carts', `${route.params.id}?display=true`)
        loading.value = false
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)

          return
        }
        item.value = res.data
      }

      onMounted(async ()=>{
        await router.isReady()
        await loadData()
      })
      return {
        loading,
        item,
        total : computed(()=>{
          if(!item.value) return 0
          let price = 0;
          for(let i = 0; i < item.value.items.length; i++) {
            price +=  item.value.items[i].price;
          }
          return price;
        }),
        formatDate : utils.formatDate,
        formatDateTime : utils.formatDateTime,
        formatPaymentMethod( method:string ) {
          if(method === 'online') return 'Pagamento online';
          return 'Pagamento a mano/in palestra';
        },
        evadiOrdine() {
          messages.requestConfirm('Richiesta evasione ordine', "Sei sicuro di voler evadere quest'ordine?", false,async ( accepted )=>{
              if(accepted) {
                let id = route.params.id;
                const res = await api.get('carts', `${id}/evaded`)
                if(!res.success) {
                  messages.error(res.message ?? Msg.serverError)
                } else {
                  messages.success("Ordine evaso!")
                }
                await loadData()
              }
            });
        },
      }
    }
  }
</script>

<style scoped></style>
